import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Spinner } from 'react-bootstrap';
import { FaMoon, FaSignOutAlt, FaSun, FaDumbbell } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { useTheme } from '../../context/ThemeContext';
import { clearAdminSession, readStoredSessionToken } from '../../utils/adminSession';
import './Logout.css';

function Logout() {
  const navigate = useNavigate();
  const { isDark, toggleTheme } = useTheme();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        const token = readStoredSessionToken();
        if (token) {
          const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}logout`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
          });

          if (response.ok) {
            clearAdminSession();
            
            await Swal.fire({
              title: 'Logout berhasil',
              text: 'Sesi admin telah ditutup dengan aman.',
              icon: 'success',
              timer: 1200,
              showConfirmButton: false,
            });
          }
        }
        clearAdminSession();
        setTimeout(() => {
          navigate('/loginadmin');
        }, 1000);
      } catch (error) {
        console.error('Logout error:', error);
        clearAdminSession();
        Swal.fire({
          title: 'Logout gagal',
          text: 'Terjadi masalah saat menutup sesi admin.',
          icon: 'error',
          timer: 1600,
          showConfirmButton: false,
        });
        navigate('/loginadmin');
      }
    };

    handleLogout();
  }, [navigate]);

  return (
    <div className="logout-page">
      <button type="button" className="logout-theme-toggle" onClick={toggleTheme}>
        {isDark ? <FaSun /> : <FaMoon />}
        <span>{isDark ? 'Light mode' : 'Dark mode'}</span>
      </button>

      <Container className="logout-shell">
        <div className="logout-content">
          <span className="logout-chip">
            <FaSignOutAlt />
            Menutup sesi admin
          </span>
          <span className="logout-mark">
            <FaDumbbell />
          </span>
          <h1>Prime Fit workspace sedang keluar</h1>
          <p>Mohon tunggu sebentar. Sistem sedang menutup sesi Anda dan mengamankan akses admin.</p>
          <Spinner animation="border" size="lg" />
        </div>
      </Container>
    </div>
  );
}

export default Logout;
